// extracted by mini-css-extract-plugin
export default {"popover":"styles_popover__7tCV3","popover-content":"styles_popover-content__PCjGC","popover-button-wrapper":"styles_popover-button-wrapper__p9TGi","button":"styles_button__3Z4Vp"};